import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelLabelEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelLabelEntity
